import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export default function PerlaCard({ icon: Icon = Sparkles, title, text, index = 0, testid }) {
  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
      className="group relative bg-white rounded-3xl p-7 md:p-8 hairline premium-shadow hover:premium-shadow-hover transition-shadow duration-500 overflow-hidden"
    >
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-brand-bright/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-gradient-to-br from-brand-cloud to-brand-silver flex items-center justify-center ring-1 ring-brand-silver/60">
          <Icon className="w-5 h-5 text-brand-medical" strokeWidth={1.4} />
        </div>
        <div className="flex-1">
          {title && (
            <p className="text-xs uppercase tracking-[0.2em] text-brand-medical/80 mb-1.5">
              Perla de salud
            </p>
          )}
          <p className="font-serif text-lg md:text-xl text-brand-deep leading-snug">
            {text}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
